import {inject, Pipe, PipeTransform} from '@angular/core';
import {DecimalPipe} from "@angular/common";

@Pipe({
    name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

    decimalPipe = inject(DecimalPipe);

    transform(size: number) {
        return this.decimalPipe.transform(size, '1.2-2') + " MB";
    }

}
